/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MEMBER" | "MODERATOR" | "STAFF" | "%future added value";
export type UserRoleChangeContainer_user = {
    readonly id: string;
    readonly username: string | null;
    readonly role: USER_ROLE;
    readonly moderationScopes: {
        readonly scoped: boolean;
        readonly sites: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
        }> | null;
    } | null;
    readonly membershipScopes: {
        readonly scoped: boolean;
        readonly sites: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
        }> | null;
    } | null;
    readonly siteUsername: ReadonlyArray<{
        readonly siteID: string | null;
        readonly name: string | null;
        readonly badges: ReadonlyArray<{
            readonly badge: string;
            readonly isUserSpecific: boolean | null;
        }> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SiteRoleActions_user">;
    readonly " $refType": "UserRoleChangeContainer_user";
};
export type UserRoleChangeContainer_user$data = UserRoleChangeContainer_user;
export type UserRoleChangeContainer_user$key = {
    readonly " $data"?: UserRoleChangeContainer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"UserRoleChangeContainer_user">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v2 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scoped",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "sites",
            "plural": true,
            "selections": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "UserRoleChangeContainer_user",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UserModerationScopes",
                "kind": "LinkedField",
                "name": "moderationScopes",
                "plural": false,
                "selections": (v2 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UserMembershipScopes",
                "kind": "LinkedField",
                "name": "membershipScopes",
                "plural": false,
                "selections": (v2 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "SiteUsername",
                "kind": "LinkedField",
                "name": "siteUsername",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "siteID",
                        "storageKey": null
                    },
                    (v1 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "BadgeRule",
                        "kind": "LinkedField",
                        "name": "badges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "badge",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isUserSpecific",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SiteRoleActions_user"
            }
        ],
        "type": "CoralUser",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'fc82f922697b3139fb049fe73616c49a';
export default node;
